import { render, staticRenderFns } from "./ReminderRow.vue?vue&type=template&id=3d4bcd36&scoped=true&"
import script from "./ReminderRow.vue?vue&type=script&lang=ts&"
export * from "./ReminderRow.vue?vue&type=script&lang=ts&"
import style0 from "./ReminderRow.vue?vue&type=style&index=0&id=3d4bcd36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4bcd36",
  null
  
)

export default component.exports